module.exports = __webpack_public_path__ + "assets/tree.1826ecf6.svg";